import React from "react"

const StaticBoardCard = ({ name, position, rank, photo, emblem }) => {
  const cardStyle = {
    display: 'flex',
    alignItems: 'flex-start',
    padding: '1rem',
    borderRadius: '12px',
    backgroundColor: 'transparent',
  }

  const photoStyle = {
    width: '150px',
    height: '150px',
    objectFit: 'cover',
    borderRadius: '8px',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    flexShrink: 0,
  }

  const contentStyle = {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: '1.25rem',
    flex: 1,
    minWidth: 0,
  }

  const nameRowStyle = {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '0.75rem',
  }

  const nameStyle = {
    fontSize: '1.125rem',
    fontWeight: '600',
    color: '#1e3a5f',
    margin: 0,
    lineHeight: 1.3,
  }

  const emblemStyle = {
    width: '100px',
    height: 'auto',
    flexShrink: 0,
  }

  const positionStyle = {
    fontSize: '0.9375rem',
    fontWeight: '500',
    color: '#4a6fa5',
    marginTop: '0.375rem',
  }

  const rankStyle = {
    fontSize: '0.875rem',
    fontWeight: '400',
    color: '#64748b',
    marginTop: '0.25rem',
  }

  return (
    <div style={cardStyle}>
      {photo && (
        <img
          src={photo}
          alt={name}
          style={photoStyle}
        />
      )}
      <div style={contentStyle}>
        <div style={nameRowStyle}>
          <span style={nameStyle}>{name}</span>
          {emblem && (
            <img
              src={emblem}
              alt="Military insignia"
              style={emblemStyle}
            />
          )}
        </div>
        {position && (
          <span style={positionStyle}>{position}</span>
        )}
        {rank && (
          <span style={rankStyle}>{rank}</span>
        )}
      </div>
    </div>
  )
}

export default StaticBoardCard
